import styled from 'styled-components'


export const H1 = styled.h1`
background-image: linear-gradient(45deg, transparent 25%, #ebebeb 25%, #ebebeb 50%, transparent 50%, transparent 75%, #ebebeb 75%, #ebebeb 100%);
background-size: 56.57px 56.57px;
`


export const H2 = styled.h2`
background-image: linear-gradient(45deg, transparent 25%, #ebebeb 25%, #ebebeb 50%, transparent 50%, transparent 75%, #ebebeb 75%, #ebebeb 100%);
background-size: 56.57px 56.57px;
`

export const H3 = styled.h3`
background-image: linear-gradient(45deg, transparent 25%, #ebebeb 25%, #ebebeb 50%, transparent 50%, transparent 75%, #ebebeb 75%, #ebebeb 100%);
background-size: 56.57px 56.57px;
`


export const H4 = styled.h4`
background-image: linear-gradient(45deg, transparent 25%, #ebebeb 25%, #ebebeb 50%, transparent 50%, transparent 75%, #ebebeb 75%, #ebebeb 100%);
background-size: 56.57px 56.57px;
`

export const H5 = styled.h5`
background-image: linear-gradient(45deg, transparent 25%, #ebebeb 25%, #ebebeb 50%, transparent 50%, transparent 75%, #ebebeb 75%, #ebebeb 100%);
background-size: 56.57px 56.57px;
`


export const P = styled.p`
background-image: linear-gradient(45deg, transparent 25%, #ebebeb 25%, #ebebeb 50%, transparent 50%, transparent 75%, #ebebeb 75%, #ebebeb 100%);
background-size: 56.57px 56.57px;
`

export const Strong = styled.strong`
background-image: linear-gradient(45deg, transparent 25%, #ebebeb 25%, #ebebeb 50%, transparent 50%, transparent 75%, #ebebeb 75%, #ebebeb 100%);
background-size: 56.57px 56.57px;
`

export const I = styled.i`
background-image: linear-gradient(45deg, transparent 25%, #ebebeb 25%, #ebebeb 50%, transparent 50%, transparent 75%, #ebebeb 75%, #ebebeb 100%);
background-size: 56.57px 56.57px;
`
